var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.external)?_c('a',{attrs:{"href":_vm.external},domProps:{"innerHTML":_vm._s(_vm.text)}}):(_vm.name)?_c('router-link',{attrs:{"to":{ name: this.name, hash: _vm.anchor }}},[_vm._v(_vm._s(_vm.text))]):_c('button',[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }